import { createSlice } from "@reduxjs/toolkit";

const RedeemReducer = createSlice({
    name: "RedeemReducer",
    initialState: {
        loading: false,
        error: false,
        success: false,
        redeemings: [],
    },
    reducers: {
        getRedeemings: (state) => {
            state.loading = true;
        },
        getRedeemingsSuccess: (state, { payload }) => {
            state.loading = false;
            state.redeemings = payload;
            state.success = true;
            state.error = false;
        },
        getRedeemingsError: (state, { payload }) => {
            state.loading = false;
            state.redeemings = [];
            state.success = false;
            state.error = payload;
        },
        redeem: (state) => {
            state.loading = true;
        },
        redeemSuccess: (state, { payload }) => {
            state.loading = false;
            state.success = true;
            state.error = false;
            state.redeemings = [payload.redemption, ...state.redeemings]
        },
        redeemError: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            state.error = payload;
        },
    },
});

export const {
    getRedeemings,
    getRedeemingsError,
    getRedeemingsSuccess,
    redeem,
    redeemError,
    redeemSuccess
} = RedeemReducer.actions;

export default RedeemReducer.reducer;
